import {
  CubeTransparentIcon,
  DateOrTime,
  Flex,
  IconButton,
  PencilSquareIcon,
  Text,
  UserAvatar,
} from 'components'
import { TemplateRecord, useBreakpoint, useUser } from 'utils'

interface Props {
  template: TemplateRecord
  onEdit?: () => void
}

export default function TemplateTileViewer({ template, onEdit }: Props) {
  const breakpoint = useBreakpoint()
  const templateCreator = useUser(template?.createdBy)
  const templateUpdater = useUser(template?.updatedBy)

  return breakpoint > 3 ? (
    <Flex width="100%" align="center" gap={3}>
      <CubeTransparentIcon />
      <Flex direction="column" justify="center" flex={1} minWidth={0}>
        <Text textStyle="bodyMedium" as="p">
          {template?.title}
        </Text>
        {template?.description?.en && <Text textStyle="bodyXSmall">{template.description.en}</Text>}
      </Flex>
      <Flex align="center" gap={3} flexShrink={0}>
        <Flex align="center" width="200px">
          <UserAvatar user={templateCreator} />
          <Text {...readOnlyTextProps}>{templateCreator?.displayName}</Text>
        </Flex>
        <Flex align="center" width="200px">
          <UserAvatar user={templateUpdater} />
          <Text {...readOnlyTextProps}>{templateUpdater?.displayName}</Text>
        </Flex>
        <DateOrTime {...readOnlyTextProps} width="120px">
          {template?.updated}
        </DateOrTime>
        {onEdit && (
          <IconButton aria-label="edit template" icon={<PencilSquareIcon />} onClick={onEdit} />
        )}
      </Flex>
    </Flex>
  ) : (
    <Flex align="center" gap={3} width="100%">
      <CubeTransparentIcon />
      <Flex direction="column" gap={1} flex={1} overflow="hidden" minWidth={0}>
        <Text textStyle="bodySmall">{template?.title}</Text>
        {template?.description?.en && (
          <Text textStyle="bodyXSmall" opacity={0.7}>
            {template.description.en}
          </Text>
        )}
      </Flex>
      {onEdit && (
        <IconButton
          aria-label="edit template"
          icon={<PencilSquareIcon />}
          onClick={onEdit}
          flexShrink={0}
        />
      )}
    </Flex>
  )
}

const readOnlyTextProps = {
  textStyle: 'bodySmall' as const,
  truncate: true,
  p: 3,
}
